import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { vehicleService } from "../../Services/vehicle.service";
import ModalSpinner from "../Components/ModalSpinner";

const ModalSearchVehicle = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [data, setData] = useState([]);

  const handleSelect = async (item) => {
    try {
      const vehicles = await vehicleService.find(item.licensePlate);
      if (vehicles && vehicles.length > 0) item = vehicles[0];
    } catch (error) {}
    setTimeout(() => {
      props.handleSelectVehicle(item);
    }, 500);
  };

  const handleClose = () => props.handleClose(!props.show);

  const infoCarLabel = (infoCar) => {
    if (infoCar === "S") {
      return <span className='badge bg-label-primary'>SIM</span>;
    }

    return <span className='badge bg-label-warning'>NÃO</span>;
  };

  useEffect(() => {
    (async () => {
      
      if (props.show) {
        if (props.filter.plate !== null) {
          setFilterName(
            <>
              <span style={{ paddingRight: "5px" }}>Filtrando por placa </span>
              <span className='badge bg-label-primary'>
                {" "}
                {props.filter.plate}
              </span>
            </>
          );

          setIsLoading(true);
          try {
            const vehicles = await vehicleService.find(props.filter.plate, props.filter.chassis);
            // A API retorna um array, então pegamos o primeiro item se existir
            setData(vehicles && vehicles.length > 0 ? vehicles[0] : null);
          } catch (error) {
            setData(null);
          } finally {
            setIsLoading(false);
          }
          return;
        }
        if (props.filter.chassis !== null) {
          setFilterName(
            <>
              <span style={{ paddingRight: "5px" }}>
                Filtrando por chassis{" "}
              </span>
              <span className='badge bg-label-primary'>
                {" "}
                {props.filter.chassis}
              </span>
            </>
          );

          setIsLoading(true);
          try {
            const vehicles = await vehicleService.find(
              "",
              props.filter.chassis
            );
            // A API retorna um array, então pegamos o primeiro item se existir
            setData(vehicles && vehicles.length > 0 ? vehicles[0] : null);
          } catch (error) {
            setData(null);
          } finally {
            setIsLoading(false);
          }
        }
      }
    })();
  }, [props]);


  return (
    <>
      <Modal
        id='modalVehicles'
        show={props.show}
        backdrop='static'
        size='lg'
        fullscreen='true'
        onHide={handleClose}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar veículo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <>
              <h5>Buscando...</h5>
              <ModalSpinner />
            </>
          ) : (
            <>
              {data ? (
                <>
                  <div className='card'>
                    <h5 className='card-header'>{filterName}</h5>
                    <div className='card-body'>
                      <table className='table table-bordered'>
                        <thead>
                          <tr>
                            <th>Placa</th>
                            <th>Chassis</th>
                            <th>Veículo</th>
                            <th>InfoCar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data && (
                            <tr style={{ cursor: "pointer" }} onClick={() => handleSelect(data)}>
                              <td>{data.licensePlate || ''}</td>
                              <td>{data.chassis || ''}</td>
                              <td>{data.vehicleModelName || ''}</td>
                              <td>
                                {data.infoCar && data.infoCar.toUpperCase() === "S" ? (
                                  <span className='badge bg-label-primary'>SIM</span>
                                ) : (
                                  <span className='badge bg-label-warning'>NÃO</span>
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h5>
                    😅Sem registros encontrados para este filtro. Mude seu
                    filtro e tente novamente!
                  </h5>
                </>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ModalSearchVehicle;
